interface validator extends HTMLElement {
    readonly validationMessage: string;
    setCustomValidity(msg: string): void;
    checkValidity(): boolean;
    focus(): void;
}

export function ReportValidity(form: validator | HTMLFormElement): boolean {
    const reportValidityEl = (el: validator): boolean => {
        if (el.checkValidity()) {
            return true;
        }

        el.classList.add('is-invalid');

        let msgTarget: HTMLElement = el;
        msgTarget = msgTarget.closest('.iti') ?? msgTarget;
        msgTarget = msgTarget.closest('.validity-parent') ?? msgTarget;
        msgTarget = msgTarget.closest('.input-group') ?? msgTarget;
        if (msgTarget.nextElementSibling instanceof HTMLLabelElement) {
            msgTarget = msgTarget.nextElementSibling;
        }
        msgTarget.classList.add('is-invalid');

        let msg = msgTarget.nextElementSibling;
        if (!msg?.classList.contains('invalid-feedback')) {
            msg = document.createElement('div');
            msg.classList.add('invalid-feedback');
        }
        msg.textContent = el.validationMessage;

        msg.setAttribute('style', `--target-width: ${msgTarget.offsetWidth.toString()}px`);
        const resizeObserver = new ResizeObserver(() => {
            msg?.setAttribute('style', `--target-width: ${msgTarget.offsetWidth.toString()}px`);
        });
        resizeObserver.observe(msgTarget);

        msgTarget.parentElement?.insertBefore(msg, msgTarget.nextElementSibling);

        const revert = () => {
            const nameValue = el.getAttribute('name');
            if (nameValue) {
                const sameNameEls: validator[] = Array.from(document.querySelectorAll(`[name=${nameValue}]`));
                if (sameNameEls.length) {
                    for (const el of sameNameEls) {
                        el.setCustomValidity('');
                        el.classList.remove('is-invalid');
                        if (el.nextElementSibling?.classList.contains('invalid-feedback')) {
                            el.nextElementSibling.remove();
                        }
                    }
                }
            } else {
                el.classList.remove('is-invalid');
                msg?.parentElement?.removeChild(msg);
            }

            msgTarget.classList.remove('is-invalid');
            resizeObserver.disconnect();

            el.removeEventListener('input', revert);
            el.removeEventListener('change', revert);
            el.removeEventListener('clearinvalid', revert);
        };
        el.addEventListener('input', revert);
        el.addEventListener('change', revert);
        el.addEventListener('clearinvalid', revert);

        return false;
    };

    if (!(form instanceof HTMLFormElement)) {
        return reportValidityEl(form);
    }

    const valid = form.checkValidity();
    if (!valid) {
        const els = Array.from(form.querySelectorAll<validator>(':invalid:not(fieldset):not(form):not([form])'));
        if (form.id) {
            els.push(...Array.from(document.querySelectorAll<validator>(`[form="${CSS.escape(form.id)}"]:invalid:not(fieldset):not(form)`)));
        }
        let firstEl: validator | undefined;

        for (const el of Array.from(els)) {
            if (!firstEl) {
                firstEl = el;
                setTimeout(() => {
                    firstEl?.focus();
                    firstEl?.scrollIntoView({
                        block: 'center',
                    });
                });
            }
            reportValidityEl(el);
        }
    }

    return valid;
}